var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 215,
    viewBox: "0 0 443 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 190L49 157L358.5 165V187L369 190L284 207.5L217.5 203.5L131.5 207.5L111.5 203.5L87 199.813L45.5 190Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7754 129.076L71.8518 29.3622L72.9923 24.3694L191.319 51.9012L279.421 67.165L318.626 121.185L306.366 118.52L357.546 129.647V189.703L280.42 194.696L208.854 192.271L131.158 194.696L110.201 192.271L104.641 190.416H83.5419H76.1287L45.9056 187.278V167.449L44.0522 165.024V163.17L45.9056 161.886V149.475H42.7692V129.076H39.7754Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1367 31.6446L118.469 113.812L207.094 123.966V121.255L119.752 109.818L73.5623 28.3636L72.1367 31.6446Z",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.894 109.818L118.896 113.812",
    stroke: "#808080",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320.052 122.086L280.135 67.1653L73.2775 26.2239L39.918 128.933H43.9097L74.7031 36.0669",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M128.163 133.926L207.094 140.334L207.805 190.15L128.163 192.271L105.923 189.846H100.934V136.922H105.923L128.163 133.926Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M358.115 129.647L279.421 113.67L207.805 121.119V126.112V190.305",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9082 128.933V149.333H52.7487V162.599H43.9082V164.454L45.3338 166.166V175.937V186.993",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.334 185.709L68.8567 187.421L74.5592 186.707L100.933 189.561L105.067 188.99L129.16 190.844L211.133 189.133L279.421 193.127L357.545 186.565V128.363",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.332 149.903V162.599",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4277 187.421L69.1426 86.423L93.093 77.5786V130.075L73.2769 131.501L73.8471 186.707",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5469 82.1434V130.93",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9688 81.0022V130.93",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6758 129.932V84.9965L93.0931 83.5699",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5464 87.2789L76.127 89.1334L76.6972 130.93",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M100.648 188.562V136.494L105.068 136.922L126.88 133.926L207.092 140.334V189.439",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.309 115.667V133.926",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M115.189 136.922V189.703",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M219.192 138.91H209.229V182.464L219.192 183.034V138.91Z",
    fill: "url(#paint2_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M129.873 135.353V190.416",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.719 137.487V190.839",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M250.338 184.425V136.922L263.454 136.779V184.996L250.338 184.425Z",
    fill: "url(#paint3_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M175.352 137.778V190.274",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M189.301 138.91V190.978",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M279.422 113.67V193.127",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.229 138.91H219.192V183.034L209.229 182.892",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M246.918 137.064V184.14L263.74 184.853V136.636L246.918 137.064Z",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M250.623 136.922V184.282",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M305.225 182.571V139.49L345.997 143.769V180.145L305.225 182.571Z",
    fill: "url(#paint4_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M305.367 136.066V182.998L349.989 180.431V141.201L305.367 136.066Z",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M305.652 139.062L345.997 143.341L349.989 141.059",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M345.998 143.769V180.145",
    stroke: "#808080",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M314.064 140.203V182.143",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M326.182 141.487V181.715",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M336.588 142.628V180.859",
    stroke: "#808080",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5645 31.7872L118.897 113.669",
    stroke: "#808080"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M76.2715 130.788V88.9908L76.8417 88.4202L80.5484 87.1364V130.788H76.2715Z",
    fill: "url(#paint5_linear)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M87.9609 130.217V85.2818L92.9506 83.9979V130.217H87.9609Z",
    fill: "url(#paint6_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M193.599 144.34L138.713 171.444V175.723L193.599 144.34Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M345.285 154.896L313.209 170.873V173.441L345.285 154.896Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M196.593 153.612L141.707 180.716V184.996L196.593 153.612Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M346.569 159.746L314.492 175.723V178.291L346.569 159.746Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M206.002 124.226L279.421 117.521L356.69 132.928",
    stroke: "#808080",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M94.0898 30.7888L128.305 91.4159L272.292 106.394L240.03 60.4095L94.0898 30.7888Z",
    fill: "#808080"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M368.725 188.586H357.783L284.524 195.133L216.347 191.148L134.505 192.856L110.451 191.005L106.323 191.575L79.9919 188.728L74.2986 189.44L50.8137 187.732H30.6367",
    stroke: "#808080",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M102.513 0.0157819C101.632 -0.127361 100.898 0.731498 101.339 1.44721L122.91 41.5273L141.84 76.5974C142.134 77.3131 142.867 77.7425 143.601 77.7425L285.063 95.3491C285.943 95.4922 286.53 94.4902 286.09 93.7745L242.7 26.8979C242.7 26.8979 242.26 26.4685 241.966 26.4685L102.513 0.0157819Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M140.197 7.25281L180.762 81.9775",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M177.205 14.3695L217.77 87.6708",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M212.076 20.7744L253.353 93.3641",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M120.982 36.431L262.603 58.4926",
    stroke: "white",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 38.5,
    y: 150,
    width: 337.5,
    height: 64.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 49,
    y1: 160,
    x2: 371.518,
    y2: 323.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 154.369,
    y1: 133.926,
    x2: 154.369,
    y2: 192.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 214.21,
    y1: 138.91,
    x2: 214.21,
    y2: 183.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 256.896,
    y1: 136.779,
    x2: 256.896,
    y2: 184.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 325.611,
    y1: 139.49,
    x2: 325.611,
    y2: 182.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 78.4099,
    y1: 87.1364,
    x2: 78.4099,
    y2: 130.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 90.4558,
    y1: 83.9979,
    x2: 90.4558,
    y2: 130.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6D0D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDefault);
export default __webpack_public_path__ + "static/media/home-default.dc4edfea3fdb2cf5ffb72ef7ffe18c05.svg";
export { ForwardRef as ReactComponent };